import React, { useCallback, memo } from "react";
import { Checkbox, Tooltip, CustomIconButton } from "../../../../components";
import { Visibility } from "../../../../icons";

const notAllowedForCampaignStatus = ["PENDING", "DELETED"];

function SelectCampaignRecipientListActions({
  recipientList,
  selectedLists,
  onToggleList,
  onOpenViewListModal,
}) {
  const onChange = useCallback(
    () => onToggleList(recipientList, recipientList._id),
    [onToggleList, recipientList]
  );
  const {
    emailCount,
    smsCount,
    voiceCount,
    ttyCount,
    customCount,
    totalCount,
    recipientCount,
    countMismatch,
  } = recipientList;
  const isStatusNotAllowed = notAllowedForCampaignStatus.includes(
    recipientList.status
  );
  const isCountValid =
    emailCount ||
    smsCount ||
    voiceCount ||
    ttyCount ||
    customCount ||
    totalCount;
  const listInvalid = isStatusNotAllowed || !isCountValid || countMismatch;

  const toolTipTitle = isStatusNotAllowed
    ? "List status not valid"
    : !isCountValid
    ? "List count not valid"
    : countMismatch
    ? `Number of recipients (${recipientCount}) for the list does not match recipient list count`
    : "List not valid";

  return (
    <div>
      <Tooltip title={listInvalid ? toolTipTitle : ""}>
        <Checkbox
          data-test-id="campaign-recipient-list-checkbox"
          color="primary"
          disabled={listInvalid}
          checked={selectedLists.indexOf(recipientList._id) !== -1}
          onChange={onChange}
        />
      </Tooltip>
      <Tooltip title={"View List"}>
        <CustomIconButton
          data-test-id={`template-action-view-${recipientList._id}`}
          size="small"
          onClick={() => onOpenViewListModal(recipientList._id)}
        >
          <Visibility fontSize="small" />
        </CustomIconButton>
      </Tooltip>
    </div>
  );
}

export default memo(SelectCampaignRecipientListActions);
